import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import useMap from './hooks/useMap'

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
}))

const Map = () => {
    const mapHook = useMap()
    const classes = useStyles()

    return (
        <div style={{ width: '100%', height: '100%' }}>
            <div className={classes.root} ref={mapHook.refElementMap}></div>
            <div ref={mapHook.refElementBasemapGallery}></div>
            <div ref={mapHook.refComponentBottomRight}>
                <div id="div-lat-lon"></div>
            </div>
        </div>
    )
}

export default Map
